import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { login } from 'src/app/ngrx/store/actions'
import { AuthUserService } from 'src/app/service/auth/auth-user.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { DdcAdCarouselComponent } from 'src/app/shared/ddc/ddc-ad-carousel/ddc-ad-carousel.component'
import { DdcAppstoreBtnSmallComponent } from 'src/app/shared/ddc/ddc-appstore-btn-small/ddc-appstore-btn-small.component'
import { Media } from 'src/app/shared/enums/enums'
import { DdcButtonROneComponent } from '../../shared/ddc/ddc-button-r-one/ddc-button-r-one.component'
import { DdcButtonSOneComponent } from '../../shared/ddc/ddc-button-s-one/ddc-button-s-one.component'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
import { CanvasPlaceholderComponent } from '../ddc-canvas/ddc-canvas-diagram/canvas-placeholder/canvas-placeholder.component'

@Component({
  selector: 'app-ddc-login',
  templateUrl: './ddc-login.component.html',
  styleUrls: ['./ddc-login.component.scss'],
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcTextGradientComponent,
    DdcButtonSOneComponent,
    DdcButtonROneComponent,
    ReactiveFormsModule,
    DdcAdCarouselComponent,
    DdcAppstoreBtnSmallComponent,
    CanvasPlaceholderComponent,
  ],
})
export class DdcLoginComponent implements OnInit {
  _isLoginBtnLoading = false
  _demoActivated = false
  _submitBtnText = 'Login'
  _demoLabel = 'Demo'
  _hide = true
  _loginError: string = ''
  _minlength = 2
  _valid_username: string = ''
  _maxlength = 50
  _passwordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-#_+]).{8,}'

  _assets = Media.MEDIA
  public slides = [
    { title: 't1', src: this._assets + '/carousel_1.png' },
    { title: 't1', src: this._assets + '/carousel_2.png' },
    { title: 't1', src: this._assets + '/carousel_3.png' },
    // { title: "t2", src: "https://miro.medium.com/max/720/0*-ATQ3-hGyZxfZqmo" },
    // { title: "t3", src: "https://miro.medium.com/max/720/0*-ATQ3-hGyZxfZqmo" },
    // { title: "t1", src: "https://miro.medium.com/max/720/0*-ATQ3-hGyZxfZqmo" },
    // { title: "t2", src: "http://www.myenglishlanguage.com/wp-content/uploads/2018/06/dictionary.jpg" },
    // { title: "t3", src: "https://www.newstatesman.com/wp-content/uploads/sites/2/2022/06/202226-OED-960x1280.jpg" },
    // { title: "t4", src: "https://snworksceo.imgix.net/bdh/000ca51c-c12e-4146-a200-4a139f1decd1.sized-1000x1000.jpg?w=1000" },
    // { title: "t4", src: "https://snworksceo.imgix.net/bdh/000ca51c-c12e-4146-a200-4a139f1decd1.sized-1000x1000.jpg?w=1000" },
  ]

  _form = new FormGroup({
    _username_or_email: new FormControl('', [
      Validators.required,
      Validators.minLength(this._minlength),
      Validators.maxLength(this._maxlength),
    ]),

    _password: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      Validators.pattern(this._passwordRegex),
    ]),
  })

  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    private authService: AuthUserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(login())
  }

  get username(): any {
    return this._form.get('_username_or_email')
  }

  get password(): any {
    return this._form.get('_password')
  }

  get_username(): void {
    if (!this._form.valid) {
      this.logger.error('DdcLoginComponent | get_username | form is invalid')
      return null
    }

    this._isLoginBtnLoading = true
    this._submitBtnText = 'Logging in...'

    this.authService.check_username_email_get_username(this._form.value).subscribe((res: any) => {
      if (res.message == 'Username exists' || res.message == 'Email exists') {
        this.logger.warn(
          'set _valid_username : ',
          res.username ? res.username : this._form.value._username_or_email,
        )
        this._valid_username = res.username ? res.username : this._form.value._username_or_email
        this.logger.warn('get_tokens')
        this.get_tokens()
      } else {
        this.logger.error('Username/Email is not registered.')
        this._loginError = 'Username/Email is not registered.'
        this._form.setErrors({
          invalidLogin: true,
        })
        this._isLoginBtnLoading = false
        this._submitBtnText = 'Login'
      }
    })
  }

  login(): void {
    this.logger.info('DdcLoginComponent | login')
    this.get_username()
  }

  demoClicked(): void {
    this._demoActivated = true
    this._demoLabel = 'Logging in to Demo Account...'
    this._form.setValue({
      _username_or_email: 'demouser1',
      _password: 'demo_Password1',
    })
    this.login()
  }

  get_tokens(): void {
    this.logger.info('DdcLoginComponent | get_tokens | _valid_username:', this._valid_username)
    this.authService
      .get_tokens(this._valid_username, this._form.value._password)
      .subscribe((res: any) => {
        if (res.message != 'Tokens sent as cookies') {
          this._loginError = 'Password is not valid'
          this._form.setErrors({
            invalidLogin: true,
          })
          this._isLoginBtnLoading = false
          this._submitBtnText = 'Login'
        } else {
          this._submitBtnText = ''
          setTimeout(() => {
            this.router.navigate(['/']).then(() => {
              window.location.reload()
            })

            this._isLoginBtnLoading = false
            this._submitBtnText = 'Login'
          }, 2000) // two seconds
        }
      })
  }

  // emailFormControl = new FormControl('', [Validators.required, Validators.email])
  // matcher = new MyErrorStateMatcher()
}
